import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

const propTypes = {
    classes: PropTypes.object.isRequired,
    type: PropTypes.oneOf([ 'h1', 'h2', 'h3', 'text', 'link', 'tableHeader','bannerTitle', 'bannerDescription'])
}

const Text = ({ classes, children, type, classList, style }) => {
    return (
        <div style={style} className={
            classNames({
                    [ classes.root ]: true,
                    [ classes[ type ] ]: true
                },
                classList
            )}
        >{children}</div>
    )
};

Text.propTypes = propTypes;

const styles = theme => ( {
    root: {},
    tableHeader: theme.typography.tableHeader,
    h1: theme.typography.h1,
    h2: theme.typography.h2,
    h3: theme.typography.h3,
    text: theme.typography.text,
    link: theme.typography.link,
    bannerTitle: theme.typography.bannerTitle,
    bannerDescription: theme.typography.bannerDescription,
    buttonText: theme.typography.buttonText,
} );

export default injectSheet(styles)(Text);



// WEBPACK FOOTER //
// ./src/app/components/Text.js